import { cn } from "@/lib/utils";

interface PageLoaderProps {
  /**
   * Fill the viewport, for screens with no layout around them: the session
   * restore in `ProtectedRoute` and the top-level lazy routes. Without it the
   * loader fills the content area of `AppLayout` / `AdminLayout`, so the
   * navbar or sidebar stays where it is while a page's code loads (#995).
   */
  fullScreen?: boolean;
}

/** The portal's page-level loading state. */
export const PageLoader = ({ fullScreen = false }: PageLoaderProps) => (
  <div
    role="status"
    className={cn(
      "flex items-center justify-center bg-background",
      fullScreen ? "min-h-screen" : "min-h-96"
    )}
  >
    <div className="flex flex-col items-center space-y-4">
      <div
        aria-hidden="true"
        className="w-8 h-8 bondit-bg-primary rounded-lg flex items-center justify-center text-white font-bold animate-pulse"
      >
        B
      </div>
      <p className="text-muted-foreground">Loading...</p>
    </div>
  </div>
);
